import { ajax } from 'cadenza/api-client/api';
import { MIMETYPE_JSON } from 'cadenza/api-client/api-constants';
import type { WorldBoxDto } from 'cadenza/api-client/dto/world-box-dto';

export class PhotoLayerApi {

  readonly #mapId: string;
  readonly #layerId: string;

  constructor (mapId: string, layerId: string) {
    this.#mapId = mapId;
    this.#layerId = layerId;
  }

  setPhotosActive (photosActive: boolean) {
    return ajax(`/maps/${this.#mapId}/layers/${this.#layerId}/photosActive`, {
      type: 'PUT',
      contentType: 'text/plain',
      data: photosActive.toString()
    });
  }

  convertToSketchLayer (bbox: WorldBoxDto, displayWidth: number, displayHeight: number) {
    return ajax(`/maps/${this.#mapId}/layers/${this.#layerId}`, {
      type: 'POST',
      contentType: MIMETYPE_JSON,
      data: JSON.stringify(this.#convertToSketchLayerSearchParam(bbox, displayWidth, displayHeight))
    });
  }

  preparePrint (srsCode: string, mapScale: number, bbox: WorldBoxDto, displacements: number[]) {
    return ajax(`/maps/${this.#mapId}/layers/${this.#layerId}/photosDisplacements`, {
      type: 'PUT',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(this.#preparePrintSearchParam(srsCode, mapScale, bbox, displacements))
    });
  }

  #convertToSketchLayerSearchParam = (bbox: WorldBoxDto, displayWidth: number, displayHeight: number) => {
    return {
      bbox,
      displayWidth,
      displayHeight
    };
  };

  #preparePrintSearchParam = (srsCode: string, mapScale: number, bbox: WorldBoxDto, displacementCoordinates: number[]) => {
    return {
      bbox,
      srsCode,
      mapScale,
      displacementCoordinates
    };
  };

}
